import React, {Fragment, useContext} from "react";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import Tags from "../Utils/Tags";
import RegistryChangeName from "../RegistryChangeName";
import Button from "../Utils/UI/Button";
import classes from "./styles.module.css";
import Context from "../../Context";

function RegistryControls({errorsCount, suggestionsTag, registryFileName, amount, fee, balance, isLoading}) {
    const {setFilterErrors, submitRegistry, clearRegistry, onChangeRegistryName, onSelectedTag} = useContext(Context);

    const hasSufficientBalance = balance && balance.balance !== undefined && amount <= balance.balance + fee;

    return (
        <div className={classes.Card}>
            <h5 className={classes.Title}>
                <FormattedMessage id="RegistryControls.title" defaultMessage="Управление реестром"/>
            </h5>

            <div className={classes.Filters}>
                <div className={classes.Row}>
                    <div className={classes.Col}>
                        {errorsCount > 0 && (
                            <div className={classes.Checkbox}>
                                <input
                                    id="showErrors"
                                    type="checkbox"
                                    onChange={(e) => setFilterErrors(e.target.checked)}
                                />
                                <label htmlFor="showErrors">
                                    <FormattedMessage id="RegistryControls.checkbox.showErrors" defaultMessage="Показать ошибки"/>
                                </label>
                            </div>
                        )}
                    </div>
                </div>

                {errorsCount === 0 && (
                    <Fragment>
                        <RegistryChangeName registryFileName={registryFileName} onChangeRegistryName={onChangeRegistryName}/>
                        <Tags
                            label={<FormattedMessage id="RegistryControls.tags.label" defaultMessage="Добавить метки"/>}
                            placeholder={<FormattedMessage id="RegistryControls.tags.placeholder" defaultMessage="Добавить метки к реестру"/>}
                            suggestions={suggestionsTag || []}
                            onChange={onSelectedTag}
                            isDisabled={!suggestionsTag || suggestionsTag.length === 0}
                        />
                    </Fragment>
                )}
            </div>

            <div className={classes.Footer}>
                <Button
                    label={<FormattedMessage id="RegistryUpload.btn.sendRegistry" defaultMessage="Отправить реестр"/>}
                    onClick={submitRegistry}
                    isLoading={errorsCount > 0 || isLoading || !hasSufficientBalance}
                />
                <button className={classes.LinkBtn} onClick={clearRegistry} disabled={isLoading}>
                    <FormattedMessage id="RegistryControls.btn.clear" defaultMessage="Очистить"/>
                </button>
            </div>
        </div>
    );
}

RegistryControls.propTypes = {
    errorsCount: PropTypes.number.isRequired,
};

export default RegistryControls;



// WEBPACK FOOTER //
// ./src/Components/RegistryControls/index.js